(ns portal.user-table.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium]]
            [common.queries :refer [use-query]]
            [common.resource.query.user :as uq]
            [common.widgets.data-grid :as dg]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as rfe]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(def columns
  #js [#js {:field "name"
            :headerName "Name"
            :sortable true
            :filterable true
            :flex 1
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:name row))}
       #js {:field "email"
            :headerName "Email Address"
            :sortable true
            :filterable true
            :flex 1
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:email row))}
       #js {:field "roleName"
            :headerName "Role"
            :sortable true
            :filterable true
            :flex 1
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:roleName row))}])

(def Toolbar
  (uix/as-react
   (fn [{:keys [create-allowed?]}]
     ($ dg/grid-toolbar
        (when create-allowed?
          ($ Button
             {:on-click #(rf/dispatch [:ocp/open {:id :user/crud}])
              :variant "contained"
              :data-testid "add-user-button"}
             "Add User"))))))

(defui user-data-grid []
  (let [{:keys [agency-id]} (use-subscribe [:url-context])
        {:keys [isPending] users :data} (use-query (uq/users-query {:agency-id agency-id}))
        {me :data} (use-query (uq/user-query))

        create-allowed? (use-subscribe [:resource.user/allowed? "useraccounts.create"])

        page-size 10

        get-row-id (uix/use-callback (fn [row]
                                       (:id row))
                                     [])

        get-row-href (uix/use-callback (fn [row]
                                         (when (= (:id me) (:id row))
                                           (rfe/href :common/user)))
                                       [me])

        on-row-click (uix/use-callback (fn [^js params]
                                         (let [user (.-row params)]
                                           (when-not (= (:id me) (:id user))
                                             (rf/dispatch [:ocp/open {:id :user/crud
                                                                      :props {:user user}}]))))
                                       [me])]
    ($ DataGridPremium
       {:columns columns

        :loading isPending

        :rows (to-array users)
        :getRowId get-row-id
        :onRowClick on-row-click

        :checkboxSelection false
        :disableRowSelectionOnClick false

        :pagination true
        :pageSizeOptions #js [page-size]

        :localeText #js {:noRowsLabel "No users have been created yet"}
        :initialState #js {:pagination #js {:paginationModel #js {:pageSize page-size}}}

        :slots #js {:toolbar Toolbar
                    :cell dg/WithLinkCell}
        :slotProps #js {:baseTextField dg/grid-toolbar-outlined-input
                        :toolbar #js {:create-allowed? create-allowed?}
                        :cell #js {:href-fn get-row-href}}

        :sx #js {:maxHeight "70rem"
                 "& .MuiDataGrid-row:hover" #js {:cursor "pointer"}}})))
